<template>
    <div
        class="relative"
        :class="{
            ['order-' + order]: order,
        }"
    >
        <DDropdown>
            <template #trigger>
                <DButton
                    theme="transparent"
                    left-icon="ph:translate"
                    right-icon="ph:caret-down"
                    size="lg"
                    class="px-2! uppercase"
                >
                    <span class="notranslate max-md:hidden">{{ currentLang }}</span>
                </DButton>
            </template>

            <DDropdownItem
                v-for="(language, index) in customLanguages"
                :key="index"
                :selected="language.code === currentLang"
                @click="triggerTranslate(language.code)"
            >
                {{ language.name }}
            </DDropdownItem>
        </DDropdown>

        <div v-show="false">
            <GoogleTranslateSelect
                v-if="translateReady"
                ref="googleTranslate"
                default-language-code="en"
                default-page-language-code="en"
                :fetch-browser-language="false"
                :languages="customLanguages"
                @error="onTranslateError"
            />
        </div>
    </div>
</template>

<script setup>
    import { DDropdown, DDropdownItem, DButton } from '@digistorm/spark'
    import GoogleTranslateSelect from '@google-translate-select/vue3'

    const googleTranslate = ref(null)
    const translateReady = ref(false)

    // The @google-translate-select/vue3 package loads the Google Translate API
    // via a <script> tag. When the script fails (network, CORS, etc.), it
    // produces an unhandled promise rejection that Vue can't catch. We suppress
    // it at the window level while the component is mounted.
    const handleUnhandledRejection = (event) => {
        if (event.reason instanceof Event && event.reason.target?.tagName === 'SCRIPT') {
            event.preventDefault()
            console.warn('Google Translate: external script failed to load')
        }
    }

    onMounted(() => {
        window.addEventListener('unhandledrejection', handleUnhandledRejection)
        translateReady.value = true
    })

    onBeforeUnmount(() => {
        window.removeEventListener('unhandledrejection', handleUnhandledRejection)
    })

    onErrorCaptured(() => false)

    const props = defineProps({
        languages: {
            type: Array,
            required: true,
        },
        order: Number,
    })

    const customLanguages = ref([{ code: 'en', name: 'English (EN)' }, ...props.languages])

    const currentLang = ref('en')

    const triggerTranslate = (languageCode) => {
        console.log(languageCode)
        currentLang.value = languageCode

        if (googleTranslate.value) {
            googleTranslate.value.handleTranslate(languageCode)
        }
    }
</script>
